import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidDetailsDelete.vue?vue&type=template&id=c159e18c&"
import script from "./GrantsConstraintsPlansSlidDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports